import CityPageTemplate from "../city-template/CityPageTemplate";
import { elizabethtownConfig } from "./data";

export default function ElizabethtownPage() {
  return <CityPageTemplate config={elizabethtownConfig} />;
}